export default "__VITE_ASSET__JxEa0UYv__"